<template>
  <template
    v-for="(button, index) in buttonsWithPermission"
    :key="index"
  >
    <BDropdown
      v-if="button.items?.length"
      :id="button.id"
      class="mr-2 mr-md-0 ml-md-2"
      :disabled="button._isDisabled"
      variant="btn btn-outline-secondary"
    >
      <template #button-content>
        <i
          v-if="button.icon"
          :class="[button.icon, 'mr-2']"
        ></i>
        {{ button.title }}
      </template>
      <BDropdownItem
        v-for="(item, itemIndex) in button.items"
        :key="itemIndex"
        :disabled="item._isDisabled"
        :title="item._tooltip"
        @click="item.click"
      >
        <i
          v-if="item.icon"
          :class="[item.icon, 'mr-2']"
        ></i>
        {{ item.title }}
      </BDropdownItem>
    </BDropdown>
    <LayoutButton
      v-else
      :id="button.id"
      class="mr-2 mr-md-0 ml-md-2"
      :disabled="button._isDisabled"
      :icon="button.icon"
      :size="button.size ?? 'md'"
      :to="button.to"
      :tooltip="button._tooltip"
      variant="btn btn-outline-secondary"
      @click="button.click"
    >
      {{ button.title }}
    </LayoutButton>
  </template>
</template>

<script lang="ts">
import { PERMISSION_DENIED_MESSAGE, usePermissions } from "@/composables/usePermissions.ts";
import authStore from "@/store/auth.js";

function withPermissionMeta(item, isAdmin) {
  const permissionValue = Array.isArray(item.permission) ? item.permission.filter(Boolean) : item.permission;

  // Se não tem permission, respeita disabled original
  if (!permissionValue || (Array.isArray(permissionValue) && permissionValue.length === 0)) {
    return { ...item, _isDisabled: item.disabled || false, _tooltip: item.tooltip || "" };
  }

  // Se é admin, respeita disabled original
  if (isAdmin) {
    return { ...item, _isDisabled: item.disabled || false, _tooltip: item.tooltip || "" };
  }

  // Verifica se tem a permission
  const { hasPermission } = usePermissions();
  const userHasPermission = hasPermission(permissionValue);

  // Desabilita se não tiver permission OU se já estava disabled
  return {
    ...item,
    _isDisabled: !userHasPermission || item.disabled || false,
    _tooltip: !userHasPermission ? PERMISSION_DENIED_MESSAGE : item.tooltip || "",
  };
}

export default {
  props: {
    buttons: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    buttonsWithPermission() {
      const currentUser = authStore.getCurrentUser();
      const isAdmin = currentUser.is_admin === 1 || currentUser.is_admin === true;

      return this.buttons.map((button) => {
        const resolved = withPermissionMeta(button, isAdmin);
        if (Array.isArray(button.items)) {
          resolved.items = button.items.map((item) => withPermissionMeta(item, isAdmin));
        }
        return resolved;
      });
    },
  },
};
</script>
